module.exports = __webpack_public_path__ + "static/media/(V)_MG_5793_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.48f95e92.jpg";